'use es6';

import { domainSuffix, hubletSuffix } from './envInfo';
const HUBSPOT_DOMAIN = `hubspot${domainSuffix}.com`;
const SIDEKICK_DOMAIN = `getsidekick${domainSuffix}.com`;
export default {
  HUBSPOT_API: `app${hubletSuffix}.${HUBSPOT_DOMAIN}`,
  HUBSPOT_LOGIN: `app${hubletSuffix}.${HUBSPOT_DOMAIN}/login`,
  SIDEKICK_API: `api${hubletSuffix}.${SIDEKICK_DOMAIN}`,
  SIDEKICK_GAE_API: `app${hubletSuffix}.${SIDEKICK_DOMAIN}`
};